// API configuration
const config = {
  // When in development, use localhost
  // When in production (Firebase), use the deployed API URL
  apiBaseUrl: process.env.NODE_ENV === 'production' 
    ? 'https://ftc-webapp-912767427361.europe-west2.run.app' // CORRECT URL
    : 'http://localhost:5000/api'
};

export default config;